import script from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainMenu.vue?vue&type=script&lang=ts&setup=true"

import "./MainMenu.vue?vue&type=style&index=0&id=198627d8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198627d8"]])

export default __exports__